import { observable, decorate, action } from "mobx";

class QueryData {
  querys = [];

  addQuery(filters) {
    const notDuplicated = [
      ...this.querys.filter(
        q => !filters.some(f => f.key === q.key && f.condition === q.condition)
      )
    ];
    this.querys.splice(0, this.querys.length);
    this.querys.push(...notDuplicated);
    this.querys.push(...filters);
  }

  removeQuery(removed) {
    const allButRemoved = [
      ...this.querys.filter(
        f => !(f.key === removed.key && f.condition === removed.condition)
      )
    ];
    this.querys.splice(0, this.querys.length);
    this.querys.push(...allButRemoved);
  }
}

decorate(QueryData, {
  querys: observable,
  addQuery: action,
  removeQuery: action
});

export default QueryData;
